<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="What time will the crew arrive?" /></div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <p>
          Mowing services are scheduled in a two day window. Your service crew often works from sun
          up to sun down, so they may come at any time throughout the day.
        </p>
        <p>
          When weather, equipment or traffic causes delays, you will receive an email notification
          of the rescheduling.
        </p>
        <p>
          If it has been more than a day since your original scheduled day and you have not received
          an email notification yet, please
          <RouterLink test-id="other_services" :to="{ name: 'crewNoShow' }">click here</RouterLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';

export default {
  name: 'WhatTimeView',
  components: {
    LsSupportHeader,
  },
};
</script>

<style lang="scss" scoped>
p:not(:last-child) {
  margin-bottom: 16px;
}
</style>
